import mitt, { type Emitter } from "mitt";
import type { ApplicationEvent } from "@/types/ApplicationEvent";

const bus: Emitter<ApplicationEvent> = mitt();

export function useEventBus() {
  function emit<K extends keyof ApplicationEvent>(
    eventName: K,
    payload: ApplicationEvent[K],
  ) {
    bus.emit(eventName, payload);
  }

  function on<K extends keyof ApplicationEvent>(
    eventName: K,
    callback: (payload: ApplicationEvent[K]) => void,
  ) {
    bus.on(eventName, callback);
  }

  function off<K extends keyof ApplicationEvent>(
    eventName: K,
    callback: (payload: ApplicationEvent[K]) => void,
  ) {
    bus.off(eventName, callback);
  }

  return {
    emit,
    on,
    off,
  };
}
